// Pure admin-decision logic for the SWA-ESTIMATING-ADMIN group check — kept
// free of React/MSAL so it is unit-testable (src/test/adminResolver.test.js).
// AdminContext.jsx gathers the inputs (token claims, a Graph call) and calls
// decideAdmin().
//
// Sources, in priority order:
//   token       — the ID token carries a `groups` claim (app registration ▸
//                 Token configuration ▸ "groups claim" for security groups).
//                 Authoritative, zero network calls.
//   graph       — no claim (or the claim was omitted for group overage), so
//                 Graph `POST /me/checkMemberGroups` answered for this group.
//   break-glass — BOTH unavailable (Graph errored) AND the signed-in email is
//                 the configured break-glass address. Never used when either
//                 real source produced a definite answer.
//   undetermined — nothing could be resolved; treated as NOT admin.

const norm = (s) => String(s || "").trim().toLowerCase();

// Entra omits `groups` and emits `_claim_names.groups` instead when a user
// is in more groups than fit in the token — treat that as "no claim" so the
// Graph fallback runs rather than reading an absent array as "no groups".
export function groupsFromClaims(claims) {
  const g = claims?.groups;
  if (Array.isArray(g)) return g.map(norm);
  return null;
}

export function decideAdmin({ claimGroups, graphGroups, graphError, email, adminGroupId, breakGlassEmail }) {
  const target = norm(adminGroupId);
  if (!target) return { isAdmin: false, source: "unconfigured" };
  if (Array.isArray(claimGroups)) {
    return { isAdmin: claimGroups.map(norm).includes(target), source: "token" };
  }
  if (Array.isArray(graphGroups)) {
    return { isAdmin: graphGroups.map(norm).includes(target), source: "graph" };
  }
  const bg = !!norm(breakGlassEmail) && norm(email) === norm(breakGlassEmail);
  return { isAdmin: bg, source: bg ? "break-glass" : "undetermined", error: graphError || null };
}
